import "./story.scss";

const Story = () => {
  return <div>asd</div>;
};

export default Story;
